











































import { Component, Ref, Vue } from 'vue-property-decorator';
import store, { State } from '@/store';
import StatCallsOperatore from '@/views/operatori/operatore/StatCallsOperatore.vue';
import { UserStatsRequest } from '@/data/models/userstats.model';
import { dateEndofDay, dateStartofDay, newDate } from '@/data/utils/helper';

@Component({
	components: {
		StatCallsOperatore
	}
})
export default class StatCallCenter extends Vue {

    @Ref('list') list!: StatCallsOperatore;

    request: UserStatsRequest = new UserStatsRequest();

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.request.hqid = this.state.headquarter!.id; 
		this.request.oid = this.state.user!.id;
		const now = newDate();
		this.request.startdate = dateStartofDay(now);
		this.request.stopdate = dateEndofDay(now);
	}

	mounted() {
		this.search();
	}

	search() {
		if (this.request.stopdate) {
			this.request.stopdate = dateEndofDay(this.request.stopdate);
		}
		this.list.reload();
	}

	reset() {
		this.init();
		this.search();
	}

	private init() {
		this.request.oid = this.state.user!.id;
		const now = newDate();
		this.request.startdate = dateStartofDay(now);
		this.request.stopdate = dateEndofDay(now);
	}

}
